import { render, staticRenderFns } from "./stockLnventoryHistory.vue?vue&type=template&id=6101b8fa&scoped=true"
import script from "./stockLnventoryHistory.vue?vue&type=script&lang=js"
export * from "./stockLnventoryHistory.vue?vue&type=script&lang=js"
import style0 from "./stockLnventoryHistory.vue?vue&type=style&index=0&id=6101b8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6101b8fa",
  null
  
)

export default component.exports